import { useEffect, useState, useCallback } from 'react';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

export type CapgoUpdateState =
  | { status: 'idle' }
  | { status: 'updateAvailable'; version: string }
  | { status: 'majorAvailable'; version: string }
  | { status: 'downloading'; progress: number }
  | { status: 'updateFailed'; error: string }
  | { status: 'appReloaded' };

export function useCapgoUpdater() {
  const [updateState, setUpdateState] = useState<CapgoUpdateState>({ status: 'idle' });

  // Handler for Capgo events
  useEffect(() => {
    function onUpdateAvailable(event: any) {
      setUpdateState({ status: 'updateAvailable', version: event?.version || '' });
    }
    function onMajorAvailable(event: any) {
      setUpdateState({ status: 'majorAvailable', version: event?.version || '' });
    }
    function onDownload(event: any) {
      setUpdateState({ status: 'downloading', progress: event?.progress || 0 });
    }
    function onUpdateFailed(event: any) {
      setUpdateState({ status: 'updateFailed', error: event?.error || 'Unknown error' });
    }
    function onAppReloaded() {
      setUpdateState({ status: 'appReloaded' });
    }

    CapacitorUpdater.addListener('updateAvailable', onUpdateAvailable);
    CapacitorUpdater.addListener('majorAvailable', onMajorAvailable);
    CapacitorUpdater.addListener('download', onDownload);
    CapacitorUpdater.addListener('updateFailed', onUpdateFailed);
    CapacitorUpdater.addListener('appReloaded', onAppReloaded);

    return () => {
      CapacitorUpdater.removeAllListeners();
    };
  }, []);

  // Optionally, expose a method to reset state
  const resetUpdateState = useCallback(() => setUpdateState({ status: 'idle' }), []);

  return { updateState, resetUpdateState };
}
